
export default (data) => ({
  alt: data?.subtitle ?? '',
  img: data?.image?.localAsset?.childImageSharp ?? null,
})
